/** Shared cache for the Module list; allows optimistic count updates from child pages. */
export const moduleCache = {
  modules: null,
  allModules: null, // when client-side pagination is used
  useClientPagination: false,
  page: 1,
  totalPages: 1,
  totalCount: 0,
  firstLoad: true,
  lastSearch: undefined,
};

export function invalidateModuleCache() {
  moduleCache.modules = null;
  moduleCache.allModules = null;
  moduleCache.useClientPagination = false;
  moduleCache.page = 1;
  moduleCache.totalPages = 1;
  moduleCache.totalCount = 0;
  moduleCache.firstLoad = true;
  moduleCache.lastSearch = undefined;
}

function coerceNumber(value) {
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
}

/**
 * Optimistically bump "module -> chapters count" in the cached modules list.
 * This keeps Module cards up-to-date immediately after adding/deleting chapters.
 */
export function bumpModuleChaptersCount(moduleId, delta = 1) {
  if (!moduleId) return;
  const targetId = String(moduleId);

  const bumpInList = (list) => {
    if (!Array.isArray(list)) return list;
    return list.map((m) => {
      const id = m?.id ?? m?._id ?? m?.module_id;
      if (id == null || String(id) !== targetId) return m;

      const current =
        coerceNumber(m?.chapters_count) ??
        coerceNumber(m?.chapter_count) ??
        coerceNumber(m?.children_count) ??
        coerceNumber(m?.child_count) ??
        (Array.isArray(m?.chapters) ? m.chapters.length : null) ??
        (Array.isArray(m?.children) ? m.children.length : null) ??
        0;

      const next = Math.max(0, current + Number(delta || 0));
      return {
        ...m,
        chapters_count: next,
        chapter_count: next,
        children_count: next,
        child_count: next,
      };
    });
  };

  moduleCache.modules = bumpInList(moduleCache.modules);
  moduleCache.allModules = bumpInList(moduleCache.allModules);
}

